// @flow
import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';
import colors from '../../assets/css/colors';
import Search from '../../components/Icons/Search';
import {
	SearchSubmitButton,
	SearchInputWrapper
} from "../../components";

const SearchField = styled(Field)`
	background: #fff;
	height: 100%;
	width: 100%;
	font-size: 12px;
	line-height: 1.5;
	color: ${colors.darkGrey};
	outline: none;
	box-sizing: border-box;
	padding: 0 48px 0 12px;
	border: none;
`;

type Props = {
	placeholder: string,
	field_name: string,
	handleSubmit: Function,
}

const SearchForm = ({ placeholder, handleSubmit, field_name }: Props) => (
	<form onSubmit={handleSubmit} autoComplete="off">
		<SearchInputWrapper>
			<SearchField type="text"
				name={field_name}
				component="input"
				placeholder={placeholder}
			/>
			<SearchSubmitButton type="submit">
				<Search />
			</SearchSubmitButton>
		</SearchInputWrapper>
	</form>
);

export default reduxForm({
	form: 'search'
})(SearchForm);


// WEBPACK FOOTER //
// ./src/components/SearchForm/index.js